import split from 'lodash/split';
import toNumber from 'lodash/toNumber';
import get from 'lodash/get';
import {
  CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
  DATE_TBA_ERROR,
} from '../../constants/error-codes';

import {
  DATE_RANGE_TYPE,
} from 'webapp-common-ui/src/constants';

export default function validateExpirationDate(eventDate, expirationMonth, expirationYear) {
  const TBA = get(eventDate, 'type', '');
  const cardYear = toNumber(expirationYear);
  const cardMonth = toNumber(expirationMonth);

  if (TBA === DATE_RANGE_TYPE.DATE_TBA || TBA === DATE_RANGE_TYPE.DATE_TBD) {
    const date = new Date();
    const currentYear = toNumber(date.getFullYear());
    const currentMonth = toNumber(date.getMonth()) + 1;
    const monthsDifference = (12 * (cardYear - currentYear)) + (cardMonth - currentMonth);

    if (monthsDifference < 24) {
      return {
        field: 'expirationYear',
        errorKey: DATE_TBA_ERROR,
        currentValue: expirationYear,
        currentValueMonth: expirationMonth,
        relatedFields: [ 'expirationMonth' ],
      };
    }
  }

  const startDate = get(eventDate, 'startDate', '');
  const yearAndMonth = split(startDate, '-');
  const eventYear = toNumber(yearAndMonth[0]);
  const eventMonth = toNumber(yearAndMonth[1]);

  if (eventYear > cardYear) {
    return {
      field: 'expirationYear',
      errorKey: CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
      currentValue: expirationYear,
      currentValueMonth: expirationMonth,
      eventYear,
      eventMonth,
      relatedFields: [ 'expirationMonth' ],
    };
  }

  if (eventYear === cardYear && eventMonth >= cardMonth) {
    return {
      field: 'expirationMonth',
      errorKey: CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT,
      currentValue: expirationMonth,
      currentValueYear: expirationYear,
      eventYear,
      eventMonth,
      relatedFields: [ 'expirationYear' ],
    };
  }

  return false;
}
